@if (license) {
  <div class="col-12 mt-6!">
    <mat-card class="cardWithShadow py-5! px-2! mb-0!">
      <mat-card-content class="px-5! py-0!">
        <mat-card-title>{{ 'license' | translate }}</mat-card-title>

        @if (license) {
          <div class="mt-6 flex flex-wrap items-center justify-between gap-4 rounded-md border border-l-4 px-4 py-4 {{ cardClasses }}">
            <div>
              <app-license-status [status]="status" />
              <div class="text-[15px] font-semibold mt-2">
                {{ license.startDate | date: 'dd.MM.yyyy' }} – {{ license.endDate | date: 'dd.MM.yyyy' }}
              </div>
              <div class="text-[13px] text-slate-500 dark:text-slate-400 mt-0.5">
                {{ (daysRemaining === 1 ? 'day remaining' : 'days remaining') | translate: { days: daysRemaining } }}
              </div>
              @if (license.cancelledAt) {
                <div class="text-[13px] text-orange-800 dark:text-orange-300 mt-0.5">
                  {{ 'license not renewing message' | translate: { date: endDateLong } }}
                </div>
              }
            </div>
            @if (!license.cancelledAt) {
            <button
              mat-stroked-button
              type="button"
              class="h-[36px]! text-[12px]! text-slate-600! border-slate-300! hover:text-red-700! hover:border-red-700! hover:bg-red-50! dark:text-slate-300! dark:border-slate-600! dark:hover:text-red-300! dark:hover:border-red-400! dark:hover:bg-red-950/40!"
              [disabled]="cancelling"
              (click)="openCancelLicense()">
              {{ 'cancel license' | translate }}
            </button>
            }
          </div>
        }
      </mat-card-content>
    </mat-card>
  </div>
}
